import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useSelector } from "react-redux";
import ListGroup from "react-bootstrap/ListGroup";
import { useNavigate } from "react-router-dom";

function OrderModal({ show, setShow, newOrder, setNewOrder }) {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);

  const handleClose = () => {
    setShow(false);
    navigate("/");
  };

  return (
    <div>
      <Modal show={show}>
        <Modal.Header>
          <Modal.Title>
            Thank you {user.firstName} for your purchase!
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="d-flex flex-column">
              <span className="text-decoration-underline">
                Order Number : {newOrder.id}
              </span>
              <span>Date : {newOrder.createdAt.split("T")[0]}</span>
            </div>
            <div className="mt-2">
              <span>Details : </span>

              <ListGroup variant="flush">
                {newOrder.product.map((item) => {
                  return (
                    <ListGroup.Item key={item.id}>
                      <div>
                        <div className="d-flex justify-content-between">
                          <div>
                            <strong>
                              {item.name} x{item.quantity}
                            </strong>
                          </div>
                          <div>
                            US$ {(item.price * item.quantity).toFixed(2)}
                          </div>
                        </div>
                        <div>Unit price: US$ {item.price}</div>
                      </div>
                    </ListGroup.Item>
                  );
                })}
              </ListGroup>
            </div>
            <div className="mt-2 d-flex flex-column">
              <span>
                <strong>Payment Method :</strong> {newOrder.payment_method}
              </span>
              <span>
                <strong>Order Status :</strong> {newOrder.status}
              </span>
              <span>
                <strong>Bill to :</strong> {user.firstName} {user.lastName}
              </span>
              <span>
                <strong>Delivery Address :</strong> {user.address}
              </span>
            </div>
            <div className="d-flex justify-content-end mt-3">
              <span className="fs-4">Total US$ {newOrder.total}</span>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default OrderModal;
